// Global Instructions Rule Applied!
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

// Meeting watches (Teams transcript ingestion) — view__meeting_watches rows,
// strict-validated before UI state.

export const MeetingWatchRowSchema = z
  .object({
    agent_meeting_watches__id: z.string(),
    agent_meeting_watches__label: z.string(),
    agent_meeting_watches__organizer_email: z.string(),
    agent_meeting_watches__organizer_user_id: z.string().nullable(),
    agent_meeting_watches__join_web_url: z.string(),
    agent_meeting_watches__online_meeting_id: z.string().nullable(),
    agent_meeting_watches__subject_match: z.string().nullable(),
    agent_meeting_watches__enabled: z.boolean(),
    agent_meeting_watches__auto_record: z.boolean(),
    agent_meeting_watches__last_polled_at: z.string().nullable(),
    agent_meeting_watches__last_transcript_at: z.string().nullable(),
    agent_meeting_watches__resolve_error: z.string().nullable(),
    agent_meeting_watches__notes: z.string().nullable(),
    agent_meeting_watches__transcript_count: z.number()
  })
  .strict()

export type MeetingWatchRow = z.infer<typeof MeetingWatchRowSchema>

export const validateMeetingWatchList = (data: unknown): MeetingWatchRow[] =>
  validateWithZodSchema(z.array(MeetingWatchRowSchema), data, 'meeting watches list')
